/**
 * Calculate the aggregate price for options that have component-based pricing
 * (e.g., STK-WRAP, CLEAR-WRAP for Urban Pavilion).
 */

const POST_ORDER_CODES = ['STKPW', 'CCPU', '8-STKPW', '8-CCPU'];

function calculateQuantity(
  orderCode: string,
  priceType: string,
  widthFt: number,
  depthFt: number,
): number {
  if (POST_ORDER_CODES.includes(orderCode)) {
    if (widthFt >= 15 && depthFt >= 15) return 9;
    if (widthFt >= 15 || depthFt >= 15) return 6;
    return 4;
  }
  if (priceType === 'LINEAR FT.') {
    return Math.round(2 * (widthFt + depthFt));
  }
  return 1;
}

export function calculateComponentPrice(
  components: Array<{ orderCode: string; pricePerUnit: number; priceType: string; upgradedPricePerUnit?: number }>,
  widthInches: number,
  depthInches: number,
  useUpgradedPrice?: boolean,
): number {
  const widthFt = widthInches / 12;
  const depthFt = depthInches / 12;

  return components.reduce((total, comp) => {
    const price = (useUpgradedPrice && comp.upgradedPricePerUnit != null)
      ? comp.upgradedPricePerUnit
      : comp.pricePerUnit;
    const quantity = calculateQuantity(comp.orderCode, comp.priceType, widthFt, depthFt);
    return total + price * quantity;
  }, 0);
}
